import { TFunction } from 'i18next';
import React, { FC, JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useHotelState } from 'src/state';

import { ReactComponent as BookIcon } from '../../../assets/icons/book.svg';
import { ReactComponent as HomeIcon } from '../../../assets/icons/home.svg';
import { ReactComponent as PinIcon } from '../../../assets/icons/map-pin.svg';
import { ReactComponent as ChatIcon } from '../../../assets/icons/reception-chat.svg';
import { ReactComponent as SpecialOfferIcon } from '../../../assets/icons/special-offer-home.svg';
import { LanguageSwitcher } from '../LanguageSwitcher';
import { Container, NavHomeItem, NavItem } from './Navigation.styled';

type MenuItem = {
  id: string;
  icon: JSX.Element;
  label?: string;
  path: string;
}

const getMenuItems = (
  t: TFunction<'translation', undefined>,
  chatAvailable?: boolean,
): Record<string, MenuItem> => ({
  home: {
    id: 'home',
    icon: <HomeIcon />,
    label: 'Start',
    path: '/',
  },
  phonebook: {
    id: 'phonebook',
    icon: <BookIcon />,
    label: t('phone_book_screen.title'),
    path: '/phonebook',
  },
  fullMenu: {
    id: 'fullMenu',
    icon: <LanguageSwitcher />,
    label: t('menu_items.special_offer'),
    path: '/',
  },
  nearby: {
    id: 'nearby',
    icon: <PinIcon />,
    label: t('menu_items.nearby'),
    path: '/nearby',
  },

  ...(chatAvailable ? {
    chat: {
      id: 'chat',
      icon: <ChatIcon />,
      label: t('chat_screen.title'),
      path: '/chat',
    },
  } : {
    specialOffer: {
      id: 'specialOffer',
      icon: <SpecialOfferIcon />,
      label: t('menu_items.special_offer'),
      path: '/special-offers',
    },
  }),
});

export const Navigation: FC = () => {
  const { hotelData } = useHotelState();
  const { t } = useTranslation();
  const menuItems = getMenuItems(t, hotelData?.chatAvailable);

  return (
    <Container>
      {Object.entries(menuItems).map(([key, { id, icon, label, path }]) => (id === 'fullMenu' ? (
        <NavHomeItem key={key}>
          {icon}
        </NavHomeItem>
      ) : (
        <NavItem key={key} to={path}>
          {icon}
          {label}
        </NavItem>
      )))}
    </Container>
  );
};
